function initCartRecent()
{
    var container = document.querySelector("[data-cart-recent]");
    var track = container ? container.querySelector("[data-recent-track]") : null;

    if (track && !track.querySelector(".healthy-home-product-card") && !track.getAttribute("data-recent-loading"))
    {
        track.setAttribute("data-recent-loading", "1");
        loadWidget(track);
    }
}

function extractEcProductData(ecCard)
{
    var dataRaw = ecCard.getAttribute("data-product-data");
    var productData = null;
    var result = null;

    if (dataRaw)
    {
        try
        {
            productData = JSON.parse(dataRaw);
        }
        catch (e) { /* invalid JSON */ }
    }

    if (productData)
    {
        var attrs = productData.attributes || {};
        var imageUrl = "";

        var imgEl = ecCard.querySelector("[data-key=\"feature_image\"]");
        var fallbackImg = imgEl ? null : ecCard.querySelector("img");
        var useImg = imgEl || fallbackImg;
        if (useImg) { imageUrl = useImg.getAttribute("src") || ""; }

        var url = productData.url || "";
        var handle = url.replace("/products/", "");

        result = {
            handle: handle,
            title: attrs.title || "",
            vendor: attrs.brand || "",
            images: imageUrl ? [{ src: imageUrl }] : [],
            variants: [{
                id: ecCard.getAttribute("data-variant-id") || "",
                price: (attrs.price || "0").replace(" GBP", ""),
                compare_at_price: (attrs.price_old || "").replace(" GBP", "") || null,
                available: true
            }],
            tags: []
        };
    }

    return result;
}

function onRecentCartFresh(freshCart)
{
    if (freshCart && freshCart.items)
    {
        try { window.Shopify.cart = freshCart; } catch (e) {}
    }
}

function onRecentCartError()
{
    /* silent fallback */
}

function fetchFreshCart(track)
{
    fetch("/cart.js", { method: "GET", headers: { "Accept": "application/json" } })
        .then(function onRecentCartResponse(r) { return r.json(); })
        .then(onRecentCartFresh)
        .catch(onRecentCartError)
        .then(function onRecentCartFinally() { checkCartQtyState(track); });
}

function handleCardRendered(track, e)
{
    var ecCard = e.target || (e.detail && e.detail.card);
    var isValid = ecCard && ecCard.getAttribute && track.contains(ecCard) && !ecCard.getAttribute("data-recent-done");

    if (isValid)
    {
        var productData = extractEcProductData(ecCard);

        if (productData && productData.handle)
        {
            var cardHtml = renderHealthyHomeProductCard(productData, []);
            track.insertAdjacentHTML("beforeend", cardHtml);
            ecCard.setAttribute("data-recent-done", "1");

            var spinner = track.querySelector(".healthy-home-panel-loading");

            if (spinner)
            {
                spinner.remove();
            }

            track.style.display = "flex";
            bindAtcButtons(track);
            fetchFreshCart(track);
        }
    }
}

function loadWidget(track)
{
    var widget = EC_CreateWidget(
    {
        "type": "did_you_forget",
        "name": "recent"
    });

    var wrapper = document.createElement("div");
    wrapper.style.display = "none";
    wrapper.setAttribute("loading", "eager");
    wrapper.appendChild(widget);
    track.appendChild(wrapper);

    var pollCount = 0;

    /* JUSTIFIED: enhancedcommerce:card_rendered is unreliable for hidden widgets — polling is the only working alternative */
    function pollForRecentCards()
    {
        var ecCards = wrapper.querySelectorAll(".ec-product-card, .product-grid__product-card");
        var anyNew = false;

        var rvCartItems = getCartItems();
        var rvCartVariantIds = [];
        for (var rvCi = 0; rvCi < rvCartItems.length; rvCi++)
        {
            rvCartVariantIds.push(String(rvCartItems[rvCi].variant_id));
        }

        for (var i = 0; i < ecCards.length; i++)
        {
            if (ecCards[i].getAttribute("data-recent-done"))
            {
                continue;
            }

            var productData = extractEcProductData(ecCards[i]);

            if (productData && productData.handle)
            {

                if (productData.variants && productData.variants[0] && !productData.variants[0].available)
                {
                    ecCards[i].setAttribute("data-recent-done", "1");
                    continue;
                }

                var firstVariantId = productData.variants && productData.variants.length > 0 ? String(productData.variants[0].id) : "";
                if (firstVariantId && rvCartVariantIds.indexOf(firstVariantId) != -1)
                {
                    ecCards[i].setAttribute("data-recent-done", "1");
                    continue;
                }

                var cardHtml = renderHealthyHomeProductCard(productData, []);
                track.insertAdjacentHTML("beforeend", cardHtml);
                ecCards[i].setAttribute("data-recent-done", "1");
                anyNew = true;
            }
        }

        if (anyNew)
        {
            var spinner = track.querySelector(".healthy-home-panel-loading");

            if (spinner)
            {
                spinner.remove();
            }

            var section = track.closest(".cart-recent");
            if (section) { section.style.display = "block"; }
            track.style.display = "flex";
            bindAtcButtons(track);
            fetchFreshCart(track);
        }

        pollCount++;

        if (pollCount < 300)
        {
            setTimeout(pollForRecentCards, 100);
        }
        else if (!anyNew && wrapper.querySelectorAll(".ec-product-card, .product-grid__product-card").length == 0)
        {
            var section = track.closest(".cart-recent");

            if (section)
            {
                section.style.display = "none";
            }
        }
    }

    pollForRecentCards();
}

document.addEventListener("DOMContentLoaded", initCartRecent);

